"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n\n  & > ", " {\n    transform: rotate(90deg);\n    margin-bottom: 1.5rem;\n    margin-right: unset;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 2.25rem;\n  margin-right: 2rem;\n  color: var(--color-primary-light-3);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.StyledFontAwesomeIcon = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(_templateObject());
var columnStyle = styled_components_1.css(_templateObject2(), exports.StyledFontAwesomeIcon);
exports.StyledActionViewWrapperDiv = styled_components_1.default.div(_templateObject3(), function (_ref) {
  var direction = _ref.direction;
  return direction === 'column' && columnStyle;
});